export const isPromotionActive = (
  now: Date,
  fromDateString: string,
  toDateString: string,
): boolean => {
  if (!fromDateString || !toDateString) return false;

  const from = new Date(fromDateString);
  const to = new Date(toDateString);

  if (Number.isNaN(from.getTime()) || Number.isNaN(to.getTime())) {
    return false;
  }

  const toInclusive = new Date(to);
  if (
    to.getHours() === 0 &&
    to.getMinutes() === 0 &&
    to.getSeconds() === 0 &&
    to.getMilliseconds() === 0
  ) {
    toInclusive.setHours(23, 59, 59, 999);
  }

  return now >= from && now <= toInclusive;
};
